"use client";

import { memo } from "react";
import type { StockListingUILabels } from "../../../interfaces/StockListingTableAEM.interface";
import StockFiltersMobileDrawer from "./StockFiltersMobileDrawer";
import StockSortDropdown, { SortOption } from "./StockSortDropdown";

export interface StockHeaderBarMobileControlsProps {
  sortValue: string;
  sortOptions: SortOption[];
  showMobileSortInDrawer?: boolean;
  showFiltersDrawer?: boolean;
  uiLabels?: StockListingUILabels;
}

const StockHeaderBarMobileControls = memo(
  ({
    sortValue,
    sortOptions,
    showMobileSortInDrawer = true,
    showFiltersDrawer = false,
    uiLabels = {},
  }: StockHeaderBarMobileControlsProps) => {
    if (showFiltersDrawer) {
      return (
        <StockFiltersMobileDrawer
          sortValue={sortValue}
          sortOptions={sortOptions}
          showSortSection={showMobileSortInDrawer}
          uiLabels={uiLabels}
        />
      );
    }

    return (
      <StockSortDropdown
        sortValue={sortValue}
        sortOptions={sortOptions}
        variant="mobile"
        uiLabels={uiLabels}
      />
    );
  },
);

StockHeaderBarMobileControls.displayName = "StockHeaderBarMobileControls";

export default StockHeaderBarMobileControls;